import React from 'react';
import DiscourseNavigation from './DiscourseNavigation';
import InfiniteScroll from 'react-infinite-scroll-component';
import ListOfDiscourse from './ListOfDiscourse';
import Button from '../../Shared/UI/Button/components/Button';

import {
  useAdminDiscourseState,
  useAdminDiscourseActions
} from './AdminDiscourseContext';
import AdminDiscourseLoader from './AdminDiscourseLoader';
import { useAdminDiscourseCapabilities } from './useAdminDiscourseCapabilities';

import {
  getDocumentsForAdmin,
} from './restApi';

import styles from './DiscourseIndex.module.scss';

const ADMIN_VIEW_STATE_OPTIONS = [
  { value: 'pending_approval', label: 'Pending Approval' },
  { value: 'pending_revision', label: 'Pending Revision' },
  { value: 'published', label: 'Published' },
  { value: 'denied', label: 'Denied' },
];

const AdminDiscourseContent = ({ authenticatedUser }) => {
  useAdminDiscourseCapabilities(authenticatedUser);
  const state = useAdminDiscourseState();
  const { onResponse, onError, setViewState } = useAdminDiscourseActions();

  const loadMoreDocuments = () => {
    const nextPageNumber = (state.pageNumberByViewState?.[state.viewState] || 0) + 1;
    getDocumentsForAdmin({
      viewState: state.viewState || 'published',
      pageNumber: nextPageNumber,
      onResponse,
      onError,
    });
  };

  return (
    <>
      <section className={styles.pageSection}>
        <DiscourseNavigation
          viewState={state.viewState}
          onViewStateChange={setViewState}
          viewStateOptions={ADMIN_VIEW_STATE_OPTIONS}
        />
      </section>
      <InfiniteScroll
        dataLength={(state.documentsByViewState?.[state.viewState] || []).length}
        next={loadMoreDocuments}
        hasMore={state.moreDocumentsAvailableByViewState?.[state.viewState] ?? true}
        loader={
          <h4 style={{ textAlign: 'center' }}>Loading...</h4>
        }
        endMessage={
          <p style={{ textAlign: 'center' }}>
            <b>You've seen all available articles</b>
          </p>
        }
        scrollableTarget="html"
      >
        <ListOfDiscourse discourse={state.documentsByViewState?.[state.viewState] || []} />
      </InfiniteScroll>
    </>
  );
};

const AdminDiscourse = ({ authenticatedUser }) => {
  return (
    <>
      <AdminDiscourseLoader />
      <AdminDiscourseContent authenticatedUser={authenticatedUser} />
    </>
  );
};

export default AdminDiscourse;
